class UsersRoleSelectorContainer {
  constructor(
    appErrorHandler,
    appSessionCapabilities,
    permissions,
    uimessages,
  ) {
    'ngInject';

    this.appErrorHandler = appErrorHandler;
    this.appSessionCapabilities = appSessionCapabilities;
    this.permissions = permissions;
    this.uimessages = uimessages;
    this.roles = [];
    this.userRole = '';
    this.ready = false;
    this.rolesWithSettings = {
      brand_admin: true,
    };
    this._warnings = {
      basic: 'This will prevent the user from accessing the application',
      super_admin: 'This will allow the user to perform all possible capabilities',
      admin: 'This will allow the user to perform almost all possible capabilities',
      read_only: 'This wont allow the user to perform any changes on the application',
    };
    this._basicRole = {
      id: 'basic',
      title: 'Basic',
      description: 'A user that can\'t log in on the application',
    };
  }
  $onInit() {
    this.permissions.loadAppRoles()
    .then((roles) => {
      this._prepareRoles(roles);
      this.ready = true;
    })
    .catch((error) => {
      this.appErrorHandler.handle(error, 'The user roles couldn\'t be loaded');
    });
  }
  selectRole(role) {
    if (this._warnings[role.id]) {
      const { displayName } = this.user;
      const title = 'Are you sure you want to change the role of ' +
        `<strong>${displayName}</strong> to <strong>${role.title}</strong>?`;

      this.uimessages.confirm(title, this._warnings[role.id], {
        confirmText: 'Change',
      })
      .then((response) => {
        if (response) {
          this.onRoleChange({ role });
        }
      });
    } else {
      this.onRoleChange({ role });
    }
  }
  openRoleSettings(role) {
    this.onRoleSettings({ role });
  }
  _prepareRoles(rolesList) {
    const roles = [];
    rolesList.forEach((role) => {
      roles[role.id] = role;
      if (this.user.permissions[role.id]) {
        this.userRole = role;
      }
    });

    if (!this.userRole) {
      this.userRole = this._basicRole;
    }

    const isSuperAdmin = this.appSessionCapabilities.isSuperAdmin();
    if (isSuperAdmin) {
      this.roles.push(...[
        roles.super_admin,
        roles.admin,
      ]);
    }

    if (this.appSessionCapabilities.isBrandAdmin(false)) {
      roles.brand_admin.title = 'Admin';
    }

    this.roles.push(roles.brand_admin);

    if (isSuperAdmin) {
      this.roles.push(roles.read_only);
    }

    this.roles.push(this._basicRole);
  }
}

export default {
  controller: UsersRoleSelectorContainer,
  template: `
    <users-role-selector
      ng-if="$ctrl.ready"
      roles="$ctrl.roles"
      roles-with-settings="$ctrl.rolesWithSettings"
      selected-role="$ctrl.userRole"
      on-selection="$ctrl.selectRole(role)"
      on-settings="$ctrl.openRoleSettings(role)"
    ></users-role-selector>
  `,
  bindings: {
    user: '<',
    onRoleChange: '&',
    onRoleSettings: '&',
  },
};
